/**
 * 配置编译环境和线上环境之间的切换
 * 
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 * 
 */
let baseUrl; 
let routerMode;
let wxUserVerifyUrl;
let ssoUrl;
let wechatUrl;
let cdoUrl;
let appUrl;
let cvoUrl;
let ambaseUrl;
let endpoint;
let cdnUrl;
let uploadRedirect;
let versionUrl;
const imgBaseUrl = 'https://fuss10.elemecdn.com';

if (process.env.VUE_APP_INNERNODE_ENV == 'development') {
	wxUserVerifyUrl='http://cvoqa.doterra.cn/wx/start';
	baseUrl = 'https://qa.doterra.cn';
	wechatUrl = 'https://wxqa.doterra.cn';
	cdoUrl = 'https://cdoqa.doterra.cn';
	ssoUrl = "https://ssoqa.doterra.cn";
	appUrl = "https://appqa.doterra.cn"
	cvoUrl = "https://cvoqa.doterra.cn"
	ambaseUrl = 'https://xhqa.dohwg.cn'
	endpoint = 'https://docstage.doterra.cn/files';
	uploadRedirect = 'https://cdnstage.dohwg.cn/images';
	cdnUrl = 'https://cdnstage.dohwg.cn/images/do'
	versionUrl = 'https://doterra-images-uat.oss-cn-hangzhou.aliyuncs.com/images/sys/website/client/version'
	routerMode = 'hash'
}else if (process.env.VUE_APP_INNERNODE_ENV == 'stage')
{

	wxUserVerifyUrl='https://cvostage.doterra.cn/wx/start';
	baseUrl = 'https://stage.doterra.cn';
	wechatUrl = 'https://wxstage.doterra.cn';
	cdoUrl = 'https://cdostage.doterra.cn';
	ssoUrl = "https://ssostage.doterra.cn";
	appUrl = "https://appstage.doterra.cn"
	cvoUrl = "https://cvostage.doterra.cn"
	ambaseUrl = 'https://xhqa.dohwg.cn'
	endpoint = 'https://docstage.doterra.cn/files';
	uploadRedirect = 'https://cdnstage.dohwg.cn/images';
	cdnUrl = 'https://cdnstage.dohwg.cn/images/do'
	versionUrl = 'https://doterra-images-uat.oss-cn-hangzhou.aliyuncs.com/images/sys/website/stage/client/version'
	// ssoUrl = 'http://127.0.0.1:8098';
	routerMode = 'hash'
}else if (process.env.VUE_APP_INNERNODE_ENV == 'qa') {
	wxUserVerifyUrl='http://cvoqa.doterra.cn/wx/start';
	baseUrl = 'https://qa.doterra.cn';
	wechatUrl = 'https://wxqa.doterra.cn';
	cdoUrl = 'https://cdoqa.doterra.cn';
	ssoUrl = "https://ssoqa.doterra.cn";
	appUrl = "https://appqa.doterra.cn"
	cvoUrl = "https://cvoqa.doterra.cn"
	ambaseUrl = 'https://xhqa.dohwg.cn'
	endpoint = 'https://docstage.doterra.cn/files';
	uploadRedirect = 'https://cdnstage.dohwg.cn/images';
	cdnUrl = 'https://cdnstage.dohwg.cn/images/do'
	versionUrl = 'https://doterra-images-uat.oss-cn-hangzhou.aliyuncs.com/images/sys/website/client/version'
	routerMode = 'hash'
	
} else {
	wxUserVerifyUrl='http://cvo.doterra.cn/wx/start';
	baseUrl = 'https://doterra.cn';
	wechatUrl = 'https://wx.doterra.cn';
	cdoUrl = 'https://cdo.doterra.cn';
	ssoUrl = "https://sso.doterra.cn";
	appUrl = "https://app.doterra.cn"
	cvoUrl = "https://cvo.doterra.cn"
	ambaseUrl = 'https://xh.dohwg.cn'
	endpoint = 'https://doc.doterra.cn/files';
	uploadRedirect = 'https://cdn.dohwg.cn/images';
	cdnUrl = 'https://cdn.dohwg.cn/images/do'
	versionUrl = 'https://doterra-images-prd.oss-cn-hangzhou.aliyuncs.com/images/sys/website/client/version'
	routerMode = 'hash'
	
}

export {
	endpoint,
	uploadRedirect,
	baseUrl,
	wechatUrl,
	cdoUrl,
	ssoUrl,
	routerMode,
	imgBaseUrl,
	wxUserVerifyUrl,
	appUrl,
	cvoUrl,
	ambaseUrl,
	cdnUrl,
	versionUrl,
}